// removed by extract-text-webpack-plugin
module.exports = {"summary":"SubjectPage__summary___2wW9G","headerContainer":"SubjectPage__headerContainer___30fG2"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/pages/SubjectPage.css
// module id = 1212
// module chunks = 0